import Card, { CardProps } from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Grid, { Grid2Props } from '@mui/material/Grid2'
import { useTheme } from '@mui/material/styles'
import { hexToRGBA } from '@repo/shared-theme-utils/font-utils'
import { generateRadialGradient } from '@repo/shared-theme-utils/style/generate-radial-gradient'
import { useResponsive } from '@repo/shared-theme-utils/hooks/useResponsive'
import type { ReactNode } from 'react'

export function ColdCard(props: { leftContent: ReactNode; rightContent: ReactNode; variant: 'full' | 'half'; cardProps?: CardProps }) {
  const { leftContent, rightContent, variant = 'full', cardProps } = props
  const theme = useTheme()

  const lgUp = useResponsive('up', 'lg')

  let gridProps: Grid2Props = { size: { md: 12, lg: 6, xl: 6 } }
  if (variant === 'half') {
    gridProps = { size: { md: 12, lg: 12, xl: 12 } }
  }

  return (
    <Card
      {...cardProps}
      sx={{
        background: generateRadialGradient(
          [
            {
              position: 'top left',
              radialSize: '90% 90%',
              color1: hexToRGBA(theme.palette.success.main, 0.12),
              color2: hexToRGBA(theme.palette.success.main, 0)
            }
          ],
          theme.palette.background.default
        ),
        ...cardProps?.sx
      }}
    >
      <CardContent sx={{ padding: '46px' }}>
        <Grid container spacing={variant === 'half' ? 2 : undefined}>
          <Grid {...gridProps}>{leftContent}</Grid>
          <Grid {...gridProps} sx={{ paddingTop: !lgUp ? 5 : undefined }}>
            {rightContent}
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}
